module.exports = __webpack_public_path__ + "img/需求调研.6408b2a8.svg";